module.exports = __webpack_public_path__ + "img/airline_seat_individual_suite.caf69e38.svg";